module.exports = __webpack_public_path__ + "img/caminhoes-econopro.896ccb06.png";